"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

var _common = require("../../common");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Copyable =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Copyable, _PureComponent);

  function Copyable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Copyable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Copyable)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      error: false,
      message: '',
      value: ''
    });

    _defineProperty(_assertThisInitialized(_this), "targetRef", _react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "handleCopy", function (e) {
      var _this$props = _this.props,
          onCopy = _this$props.onCopy,
          successText = _this$props.successText,
          errorText = _this$props.errorText,
          decode = _this$props.decode;
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation'); // default to use state value (getValue)

      var value = _this.state.value; // with refs

      var targetNode = _this.targetRef.current;

      if (targetNode) {
        if (targetNode.value) {
          value = targetNode.value;
        }

        if (targetNode.innerHTML) {
          // support for node without value attribute
          value = targetNode.innerHTML;
        }
      } // decode


      if (decode) value = _this.decodeHTML(value); // copy text

      var error = _this.copyTextToClipboard(value);

      _this.setState({
        error: error,
        message: error ? errorText : successText,
        value: value
      }, function () {
        if (onCopy) {
          onCopy(e, {
            error: error,
            message: _this.state.message,
            value: value
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "decodeHTML", function (html) {
      var str = document.createElement('textarea');
      str.innerHTML = html;
      str.remove();
      return str.value;
    });

    _defineProperty(_assertThisInitialized(_this), "copyTextToClipboard", function () {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var error = false;

      if ((0, _lib.isString)(text) || (0, _lib.isNumber)(text)) {
        // Create new element
        var temp = document.createElement('textarea'); // Set value (string to be copied)

        temp.value = text; // Set non-editable to avoid focus and move outside of view

        var style = 'position: absolute, left: -9999px';
        temp.setAttribute('style', style);
        temp.setAttribute('readonly', '');
        document.body.appendChild(temp); // Select text inside element

        temp.select();

        try {
          // Copy text to clipboard
          var success = document.execCommand('copy');
          if (!success) error = true;
        } catch (err) {
          error = true;
        } // Remove temporary element


        document.body.removeChild(temp);
        return error;
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "handleGetValue", function (e, _ref) {
      var value = _ref.value;
      return _this.setState({
        value: value
      });
    });

    return _this;
  }

  _createClass(Copyable, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return (0, _lib.getRenderProps)(children, {
        copy: this.handleCopy,
        targetRef: this.targetRef,
        getValue: this.handleGetValue,
        error: this.state.error,
        message: this.state.message
      });
    }
  }]);

  return Copyable;
}(_react.PureComponent);

exports["default"] = Copyable;

_defineProperty(Copyable, "propTypes", {
  children: _common.customPropTypes.render.isRequired,
  successText: _propTypes["default"].string,
  errorText: _propTypes["default"].string,
  onCopy: _propTypes["default"].func,
  decode: _propTypes["default"].bool
});

_defineProperty(Copyable, "defaultProps", {
  onCopy: null,
  successText: 'Copied to the clipboard.',
  errorText: 'Failed to copy.',
  decode: false
});